<template>
    <div class="BS_ParamSetting">
        <el-card class="box-card" shadow="hover">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="提现设置" name="withdraw">
                    <el-form :model="paramForm" label-position="right" label-width="100px">
                        <el-form-item label="起提金额：">
                            <el-input
                                size="medium"
                                v-model="paramForm.withdraw_money"
                                placeholder="请输入起提金额"
                            >
                                <span slot="suffix" style="font-size:12px">元</span>
                            </el-input>
                            <div style="color:red;font-size:12px;">注意：起提金额为：10元 - 100000元。</div>
                        </el-form-item>
                        <el-form-item label="到账时间：">
                            <el-input
                                size="medium"
                                v-model="paramForm.withdraw_day"
                                placeholder="请输入到账时间"
                            >
                                <span slot="suffix" style="font-size:12px">天</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="代收税点：">
                            <el-radio-group v-model="paramForm.withdraw_fee_switch">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="0">关闭</el-radio>
                            </el-radio-group>
                            <template v-if="paramForm.withdraw_fee_switch == 1">
                                <div>
                                    <el-radio-group v-model="paramForm.withdraw_feetype_switch">
                                        <el-radio label="1">按照金额</el-radio>
                                        <el-radio label="2">按照比例</el-radio>
                                    </el-radio-group>
                                </div>
                                <template v-if="paramForm.withdraw_feetype_switch == 2">
                                    <el-input
                                        size="medium"
                                        v-model="paramForm.withdraw_rate"
                                        placeholder="请输入比例"
                                        key="rate"
                                    >
                                        <span slot="suffix" style="font-size:12px">%</span>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input
                                        size="medium"
                                        v-model="paramForm.withdraw_fee"
                                        placeholder="请输入金额"
                                        key="fee"
                                    >
                                        <span slot="suffix" style="font-size:12px">元</span>
                                    </el-input>
                                </template>
                            </template>
                        </el-form-item>
                        <el-form-item label="出款服务费：">
                            <el-radio-group v-model="paramForm.service_fee_status">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="2">关闭</el-radio>
                            </el-radio-group>
                            <template v-if="paramForm.service_fee_status == 1">
                                <div>
                                    <el-radio-group v-model="paramForm.service_fee_switch">
                                        <el-radio label="1">按照金额</el-radio>
                                        <el-radio label="2">按照比例</el-radio>
                                    </el-radio-group>
                                </div>
                                <template v-if="paramForm.service_fee_switch == 2">
                                    <el-input
                                        size="medium"
                                        v-model="paramForm.service_fee_rate"
                                        placeholder="请输入比例"
                                        key="rate"
                                    >
                                        <span slot="suffix" style="font-size:12px">%</span>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input
                                        size="medium"
                                        v-model="paramForm.service_fee_money"
                                        placeholder="请输入金额"
                                        key="fee"
                                    >
                                        <span slot="suffix" style="font-size:12px">元</span>
                                    </el-input>
                                </template>
                            </template>
                        </el-form-item>
                        <el-form-item label="提现是否秒到：">
                            <el-radio-group v-model="paramForm.at_once_status">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                            </el-radio-group>
                            <template v-if="paramForm.at_once_status == 1">
                                <el-form :inline="true">
                                    <el-form-item>
                                        <span style="font-size:12px">提现金额大于</span>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input
                                            size="medium"
                                            v-model="paramForm.at_once_money"
                                            placeholder="请输入比例"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <span style="font-size:12px">
                                            元
                                            ，时需要审核
                                        </span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-form-item>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="withdrawSubmit(paramForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="邮箱设置" name="email">
                    <el-form :model="emailForm" label-position="right" label-width="120px">
                        <el-form-item label="邮箱服务地址：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_smtp_host"
                                placeholder="请输入邮箱服务地址"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱服务端口：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_smtp_port"
                                placeholder="请输入邮箱服务端口"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发送者邮箱：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_from"
                                placeholder="请输入发送者邮箱"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发送者名称：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_from_name"
                                placeholder="请输入发送者名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="三方登录用户名：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_smtp_user"
                                placeholder="请输入三方登录用户名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="三方登录密码：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_smtp_pass"
                                placeholder="请输入三方登录密码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱验证类型：">
                            <el-input
                                size="medium"
                                v-model="emailForm.mail_verify_type"
                                placeholder="请输入邮箱验证类型ssl或tls类型"
                            ></el-input>
                            <div class="warmTips" style="margin:0">温馨提示：常用邮箱验证类型为ssl与tls。</div>
                        </el-form-item>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="emailSubmit(emailForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="接收设置" name="accept">
                    <el-form :model="acceptForm" label-position="right" label-width="120px">
                        <el-form-item label="是否默认接收：">
                            <el-radio-group v-model="acceptForm.is_open">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="0">关闭</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="acceptForm.is_open != 0">
                            <el-form-item label="设置时间(分钟)：">
                                <el-input
                                    size="medium"
                                    v-model="acceptForm.time"
                                    placeholder="请输入时间"
                                ></el-input>
                            </el-form-item>
                            <div class="warmTips">
                                温馨提示：上级给下级划拨时，判断是否默认接收；例如：
                                开启，时间设置为10分钟，则上级给下级划拨机器后，10分钟内下级未接收时，则系统默认接收；
                                关闭，则不默认接收，需等待下级操作。
                            </div>
                        </template>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="acceptSubmit(acceptForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="在线客服" name="service">
                    <el-form :model="serviceForm" label-position="right" label-width="100px">
                        <el-form-item label="客服类型：">
                            <el-radio-group v-model="serviceForm.online_service_type">
                                <el-radio label="1">云客服</el-radio>
                                <el-radio label="2">自定义客服</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="serviceForm.online_service_type == 2">
                            <el-form-item label="后台链接地址：">
                                <el-input
                                    size="medium"
                                    v-model="serviceForm.online_service_admin_url"
                                    placeholder="请输入后台链接地址"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="APP链接地址：">
                                <el-input
                                    size="medium"
                                    v-model="serviceForm.online_service_app_url"
                                    placeholder="请输入APP链接地址"
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="serviceSubmit(serviceForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="补贴手续费设置" name="subsidy_fee">
                    <el-form :model="subsidyForm" label-position="right" label-width="120px">
                        <el-form-item label="是否收取手续费：">
                            <el-radio-group v-model="subsidyForm.is_open">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="0">关闭</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="收取比例：" v-if="subsidyForm.is_open != 0">
                            <el-input
                                size="medium"
                                v-model="subsidyForm.proportion"
                                placeholder="请输入比例"
                            >
                                <span slot="suffix" style="font-size:12px">%</span>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="subsidySubmit(subsidyForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="商户提现设置" name="merchant_withdraw">
                    <el-form :model="merchantWithdrawForm" label-position="right" label-width="100px">
                        <el-form-item label="起提金额：">
                            <el-input
                                size="medium"
                                v-model="merchantWithdrawForm.withdraw_money"
                                placeholder="请输入起提金额"
                            >
                                <span slot="suffix" style="font-size:12px">元</span>
                            </el-input>
                            <div style="color:red;font-size:12px;">注意：起提金额为：10元 - 100000元。</div>
                        </el-form-item>
                        <el-form-item label="到账时间：">
                            <el-input
                                size="medium"
                                v-model="merchantWithdrawForm.withdraw_day"
                                placeholder="请输入到账时间"
                            >
                                <span slot="suffix" style="font-size:12px">天</span>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="代收税点：">
                            <el-radio-group v-model="merchantWithdrawForm.withdraw_fee_switch">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="0">关闭</el-radio>
                            </el-radio-group>
                            <template v-if="merchantWithdrawForm.withdraw_fee_switch == 1">
                                <div>
                                    <el-radio-group v-model="merchantWithdrawForm.withdraw_feetype_switch">
                                        <el-radio label="1">按照金额</el-radio>
                                        <el-radio label="2">按照比例</el-radio>
                                    </el-radio-group>
                                </div>
                                <template v-if="merchantWithdrawForm.withdraw_feetype_switch == 2">
                                    <el-input
                                        size="medium"
                                        v-model="merchantWithdrawForm.withdraw_rate"
                                        placeholder="请输入比例"
                                        key="rate"
                                    >
                                        <span slot="suffix" style="font-size:12px">%</span>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input
                                        size="medium"
                                        v-model="merchantWithdrawForm.withdraw_fee"
                                        placeholder="请输入金额"
                                        key="fee"
                                    >
                                        <span slot="suffix" style="font-size:12px">元</span>
                                    </el-input>
                                </template>
                            </template>
                        </el-form-item>
                        <el-form-item label="出款服务费：">
                            <el-radio-group v-model="merchantWithdrawForm.service_fee_status">
                                <el-radio label="1">开启</el-radio>
                                <el-radio label="2">关闭</el-radio>
                            </el-radio-group>
                            <template v-if="merchantWithdrawForm.service_fee_status == 1">
                                <div>
                                    <el-radio-group v-model="merchantWithdrawForm.service_fee_switch">
                                        <el-radio label="1">按照金额</el-radio>
                                        <el-radio label="2">按照比例</el-radio>
                                    </el-radio-group>
                                </div>
                                <template v-if="merchantWithdrawForm.service_fee_switch == 2">
                                    <el-input
                                        size="medium"
                                        v-model="merchantWithdrawForm.service_fee_rate"
                                        placeholder="请输入比例"
                                        key="rate"
                                    >
                                        <span slot="suffix" style="font-size:12px">%</span>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input
                                        size="medium"
                                        v-model="merchantWithdrawForm.service_fee_money"
                                        placeholder="请输入金额"
                                        key="fee"
                                    >
                                        <span slot="suffix" style="font-size:12px">元</span>
                                    </el-input>
                                </template>
                            </template>
                        </el-form-item>
                        <el-form-item label="提现是否秒到：">
                            <el-radio-group v-model="merchantWithdrawForm.at_once_status">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                            </el-radio-group>
                            <template v-if="merchantWithdrawForm.at_once_status == 1">
                                <el-form :inline="true">
                                    <el-form-item>
                                        <span style="font-size:12px">提现金额大于</span>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-input
                                            size="medium"
                                            v-model="merchantWithdrawForm.at_once_money"
                                            placeholder="请输入比例"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <span style="font-size:12px">
                                            元
                                            ，时需要审核
                                        </span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-form-item>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="merchantWithdrawSubmit(merchantWithdrawForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                
                <el-tab-pane label="代付通道设置" name="pay_channel">
                    <el-form :model="payForm" label-position="right" label-width="100px">
                        <el-form-item label="代付通道：">
                            <el-radio-group v-model="payForm.channel_id">
                                <el-radio label="1">云账户代付</el-radio>
                                <el-radio label="3">京灵代付</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="签约服务商：" v-if="payForm.channel_id == 3">
                            <el-radio-group v-model="payForm.contract_code">
                                <el-radio
                                v-for="contract in contractList"
                                :key="contract.contractCode"
                                :label="contract.contractCode">{{contract.serviceCompanyName}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            :loading="loading"
                            style="font-size: 12px;"
                            @click="daifuSubmit(payForm)"
                        >保存设置</el-button>
                    </div>
                </el-tab-pane>
                
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "BS_ParamSetting",
    data() {
        return {
            activeName: 'withdraw',
            loading: false,
            paramForm: {},
            emailForm: {},
            acceptForm: {},
            serviceForm: {},
            subsidyForm: {},
            merchantWithdrawForm: {},
            payForm: {},
        }
    },
    mounted() {
        this.getDetail({ k: 'withdraw' });//初始化
        this.getDetail({ k: 'email' });//初始化
        this.getDetail({ k: 'receive' });//初始化
        this.getDetail({ k: 'online_service' });//初始化
        this.getDetail({ k: 'subsidy_fee' });//初始化
        this.getDetail({ k: 'merchant_withdraw' });//初始化
        this.getDetail({ k: 'pay_channel' });//初始化
        this.getContractList();
    },
    methods: {
        getContractList() {
            this.$api.post('jingling/contractList', {}, res => {
                console.log("hetongbianhao", res);
                this.contractList = res.data;
            });
        },
        handleClick() {

        },
        withdrawSubmit(paramForm) { //提现提交
            let reg = /^\d+(\.\d+)?$/;
            // 代收税点校验
            if (paramForm.withdraw_fee_switch == 1) {
                if (paramForm.withdraw_feetype_switch == 1) {
                    paramForm.withdraw_rate = '';
                    if (!reg.test(paramForm.withdraw_fee)) {
                        this.$message.error('代收税点格式需为数字');
                        return false;
                    }
                } else {
                    paramForm.withdraw_fee = '';
                    if (!reg.test(paramForm.withdraw_rate)) {
                        this.$message.error('代收税点格式需为数字');
                        return false;
                    }
                }
            }
            // 出款服务费校验
            if (paramForm.service_fee_status == 1) {
                if (paramForm.service_fee_switch == 1) {
                    paramForm.service_fee_rate = '';
                    if (!reg.test(paramForm.service_fee_money)) {
                        this.$message.error('出款服务费格式需为数字');
                        return false;
                    }
                } else {
                    paramForm.service_fee_money = '';
                    if (!reg.test(paramForm.service_fee_rate)) {
                        this.$message.error('出款服务费格式需为数字');
                        return false;
                    }
                }
            }
            // let reqData;
            // if (paramForm.withdraw_fee_switch != 1) { //关闭
            //     reqData = this._.pick(paramForm, ['withdraw_money', 'withdraw_day', 'withdraw_fee_switch']);
            // } else { //开启
            //     if (paramForm.withdraw_feetype_switch != 1) { //按照金额
            //         reqData = this._.omit(paramForm, ['withdraw_fee']);
            //     } else { //按照比例
            //         reqData = this._.omit(paramForm, ['withdraw_rate']);
            //     }
            // }
            paramForm.k = 'withdraw';
            this.sendParams(paramForm);
        },
        emailSubmit(emailForm) { //邮箱提交
            emailForm.k = "email";
            this.sendParams(emailForm);
        },
        acceptSubmit(acceptForm) { //接收提交
            acceptForm.k = "receive";
            this.sendParams(acceptForm);
        },
        serviceSubmit(serviceForm) { //在线客服提交
            serviceForm.k = "online_service";
            this.sendParams(serviceForm);
        },
        daifuSubmit(payForm) { //在线客服提交
            payForm.k = "pay_channel";
            this.sendParams(payForm);
        },
        subsidySubmit(subsidyForm) { //补贴手继续设置
            subsidyForm.k = "subsidy_fee";
            this.sendParams(subsidyForm);
        },
        merchantWithdrawSubmit(merchantWithdrawForm) { //商户提现设置提交
            let reg = /^\d+(\.\d+)?$/;
            // 代收税点校验
            if (merchantWithdrawForm.withdraw_fee_switch == 1) {
                if (merchantWithdrawForm.withdraw_feetype_switch == 1) {
                    merchantWithdrawForm.withdraw_rate = '';
                    if (!reg.test(merchantWithdrawForm.withdraw_fee)) {
                        this.$message.error('代收税点格式需为数字');
                        return false;
                    }
                } else {
                    merchantWithdrawForm.withdraw_fee = '';
                    if (!reg.test(merchantWithdrawForm.withdraw_rate)) {
                        this.$message.error('代收税点格式需为数字');
                        return false;
                    }
                }
            }
            // 出款服务费校验
            if (merchantWithdrawForm.service_fee_status == 1) {
                if (merchantWithdrawForm.service_fee_switch == 1) {
                    merchantWithdrawForm.service_fee_rate = '';
                    if (!reg.test(merchantWithdrawForm.service_fee_money)) {
                        this.$message.error('出款服务费格式需为数字');
                        return false;
                    }
                } else {
                    merchantWithdrawForm.service_fee_money = '';
                    if (!reg.test(merchantWithdrawForm.service_fee_rate)) {
                        this.$message.error('出款服务费格式需为数字');
                        return false;
                    }
                }
            }
            // let reqData;
            // if (merchantWithdrawForm.withdraw_fee_switch != 1) { //关闭
            //     reqData = this._.pick(merchantWithdrawForm, ['withdraw_money', 'withdraw_day', 'withdraw_fee_switch']);
            // } else { //开启
            //     if (merchantWithdrawForm.withdraw_feetype_switch != 1) { //按照金额
            //         reqData = this._.omit(merchantWithdrawForm, ['withdraw_fee']);
            //     } else { //按照比例
            //         reqData = this._.omit(merchantWithdrawForm, ['withdraw_rate']);
            //     }
            // }
            merchantWithdrawForm.k = 'merchant_withdraw';
            this.sendParams(merchantWithdrawForm);
        },
        getDetail(reqData) { //获取详情
            this.$api.post('setting/getSetting', reqData, res => {
                if (res.code == 0) {
                    if (reqData.k == "withdraw") {
                        this.paramForm = res.data;
                    }
                    if (reqData.k == "receive") {
                        this.acceptForm = res.data;
                    }
                    if (reqData.k == "email") {
                        this.emailForm = res.data;
                    }
                    if (reqData.k == "online_service") {
                        this.serviceForm = res.data;
                    }
                    if (reqData.k == "subsidy_fee") {
                        this.subsidyForm = res.data;
                    }
                    if (reqData.k == "merchant_withdraw") {
                        this.merchantWithdrawForm = res.data;
                    }
                    if (reqData.k == "pay_channel") {
                        this.payForm = res.data;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        sendParams(reqData) { //请求
            this.loading = true;
            this.$api.post('setting/update_setting', reqData, res => {
                let that = this;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 1500,
                        onClose() {
                            that.loading = false;
                        }
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 1500,
                        onClose() {
                            that.loading = false;
                        }
                    });
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.BS_ParamSetting {
    ::v-deep .el-form {
        min-width: 500px;
        .el-input {
            max-width: 500px;
        }
    }
    .warmTips {
        margin-left: 120px;
        width: 500px;
        font-size: 12px;
        color: red;
    }
}
</style>
